import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  cachesTitle: {
    id: 'frontbucket.pipelines.common.caches.title',
    description:
      'The title of the caches section in the pipeline list action menu',
    defaultMessage: 'Dependency caches',
  },

  noCachesHeader: {
    id: 'frontbucket.pipelines.common.noCaches.header',
    description: 'Header text when no caches are present',
    defaultMessage: "You haven't added any dependency caches yet",
  },
  noCachesDescription: {
    id: 'frontbucket.pipelines.common.noCaches.description',
    description:
      'Description when no caches are present. The "Learn more" link text is wrapped in <link> tags.',
    defaultMessage:
      'Speed up your build by caching your dependencies. <link>Learn more</link>',
  },
  learnMoreButton: {
    id: 'frontbucket.pipelines.common.learnMoreButton',
    description: 'Text for the learn more button',
    defaultMessage: 'Learn more',
  },
  deleteCachesTooltip: {
    id: 'frontbucket.pipelines.common.deleteCachesTooltip',
    description: 'Tooltip text for the delete caches button',
    defaultMessage: 'Delete caches',
  },
  deleteCacheModalTitle: {
    id: 'frontbucket.pipelines.common.deleteCacheModalTitle',
    description: 'Title for the delete cache modal',
    defaultMessage: 'Delete cache{pluralSuffix}',
  },
  deleteCacheModalBodyGroup: {
    id: 'frontbucket.pipelines.common.deleteCacheModalBodyGroup',
    description:
      'Body text for the delete cache modal when deleting a group. The cache name is wrapped in <bold> tags so it can be visually emphasised.',
    defaultMessage:
      'Are you sure you want to delete the <bold>{cacheName}</bold> cache and all associated versions?',
  },
  deleteCacheModalBodySingle: {
    id: 'frontbucket.pipelines.common.deleteCacheModalBodySingle',
    description:
      'Body text for the delete cache modal when deleting a single version. The parent cache name is wrapped in <bold> tags so it can be visually emphasised. The {hasVersion} value selects between an unversioned variant and a versioned variant of the sentence ("version {label} of").',
    defaultMessage:
      'Are you sure you want to delete {hasVersion, select, true {version {label} of } other {}}the <bold>{parentCacheName}</bold> cache created on {creationDate}?',
  },
  cancelButton: {
    id: 'frontbucket.pipelines.common.cancelButton',
    description: 'Text for the cancel button',
    defaultMessage: 'Cancel',
  },
  deleteButton: {
    id: 'frontbucket.pipelines.common.deleteButton',
    description: 'Text for the delete button',
    defaultMessage: 'Delete',
  },
  cachesButton: {
    id: 'frontbucket.pipelines.common.cachesButton',
    description: 'Text for the caches button',
    defaultMessage: 'Caches',
  },
});
